import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Grid from '@material-ui/core/Grid';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import EquipmentAssignmentContainer from '../../containers/EquipmentAssignment';

//- UI / Form
import FormContainer from '../../components/FormContainer';
import SectionHeader from '../../components/SectionHeader';
import LocationSelect from '../../components/advancedForm/LocationSelect';
import FormDatePicker from '../../components/form/FormDatePicker';
import EquipmentAssignmentShiftSchedules from '../../components/advancedForm/EquipmentAssignmentShiftSchedules';
import calendarConfig from '../../libs/calendarConfig';
import FormSubmitButton from '../../components/form/FormSubmitButton';
import EquipmentScheduleTypeSelect from '../../components/advancedForm/EquipmentScheduleTypeSelect';
import FormComponent from '../../components/FormComponent';
import EquipmentAssignmentTable from './Table';
import { getGlobalClasses } from '../../themes';
import { getEquipmentAssignmentType } from '../../libs/user';
import SmartEquipmentSelect from '../../components/advancedForm/SmartEquipmentSelect';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		pickToShow: {
			padding: 10,
			background: '#fEfEfE',
			border: '1px solid #ddd',
			color: '#333',
			borderRadius: 2,
		},
		notCurrentlyAssigned: {
			fontSize: 20,
			borderBottom: '1px solid #ddd',
			paddingBottom: 5,
			marginBottom: 10,
		},
		assignmentHelper: {
			padding: 20,
			border: '1px solid #eee',
			margin: 10,
			marginTop: 40,
			backgroundColor: '#f7f7f7',
			borderRadius: 5,
		},
		notSelectedLocation: {
			opacity: 0.3,
		},
		selectedLocation: {
			borderLeft: '3px solid #1289d4',
		},
		locationContainer: {
			padding: 10,
		},
		locationHeader: {
			borderBottom: '1px solid #ddd',
			paddingBottom: 5,
			marginBottom: 5,
		},
		location: {
			fontSize: '200%',
			paddingRight: 10,
		},
		locationCount: {
			fontWeight: 200,
			color: '#333',
		},
		locationTitle: {
			textTransform: 'uppercase',
			letterSpacing: 2,
			fontSize: 13,
			borderBottom: '1px solid #ddd',
			marginBottom: 20,
		},
		shiftTimeTruck: {
			marginLeft: 20,
			display: 'flex',
		},
		truckInfo: {
			color: '#555',
			fontWeight: 500,
			marginLeft: 5,
		},
		shiftTitle: {
			fontSize: '120%',
			marginLeft: 5,
		},
		smallSemiTruckIcon: {
			display: 'inline-block',
			width: 11,
			height: 11,
			verticalAlign: 'middle',
			marginRight: 5,
		},
	};
};

const idField = 'equipmentAssignmentId';
//const itemDisplay = 'Equipment Assignment';

class SaveEquipmentAssignment extends FormComponent {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);
		const isUpdate = action === 'update';
		const isReassign = action === 'reassign';

		this.requiredPathMap = {};

		// noinspection JSUnresolvedFunction
		this.state = {
			isUpdate,
			isReassign,
			[idField]: id,
			startDate: moment().format('YYYY-MM-DD'),
			endDate: undefined,
			locationId: '',
			shiftSchedules: [],
			formFieldError: {},
			equipmentAssignmentsByLocation: [],
		};
		// this.state.locationId = 2;
		// this.state.equipmentAssignmentTypeId = 'user-abc-c-shift';
	}
	componentDidMount() {
		const {
			equipmentAssignment,
			getEquipmentAssignment,
			equipmentAssignments,
			searchEquipmentAssignments,
		} = this.props;
		const { equipmentAssignmentId, isUpdate, isReassign } = this.state;

		if (_.isEmpty(equipmentAssignments)) {
			searchEquipmentAssignments();
		}

		//- update
		if (!isUpdate && !isReassign) {
			return;
		}
		if (equipmentAssignment) {
			this.fillForm({ equipmentAssignment });
		} else {
			getEquipmentAssignment({
				params: { equipmentAssignmentIds: [equipmentAssignmentId] },
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const {
			equipmentAssignment,
			searchEquipmentAssignmentsByEquipment,
			showErrors,
			equipmentAssignments,
		} = this.props;

		if (_.isUndefined(prevProps.equipmentAssignment) && !_.isUndefined(equipmentAssignment)) {
			this.fillForm({ equipmentAssignment });
		}

		if (!_.isEmpty(equipmentAssignments) && _.isEmpty(this.state.equipmentAssignmentsByLocation)) {
			this.formatEquipmentByTerminal({ equipmentAssignments });
		}

		const { equipmentId } = this.state;
		if (prevState.equipmentId !== equipmentId && equipmentId) {
			searchEquipmentAssignmentsByEquipment({
				equipmentId,
				callback: (err, r) => {
					if (err) {
						showErrors([err]);
						return;
					}

					const equipmentAssignments = _.get(r, 'collections.equipmentAssignmentCollection', []);

					let currentEquipmentAssignment = null;
					let pastEquipmentAssignments = [];

					equipmentAssignments.forEach((equipmentAssignment) => {
						const { isPast } = equipmentAssignment;

						if (isPast) {
							pastEquipmentAssignments.push(equipmentAssignment);
						} else {
							currentEquipmentAssignment = equipmentAssignment;
						}
					});

					this.setState({
						currentEquipmentAssignment,
						pastEquipmentAssignments,
					});
				},
			});
		}
	}

	fillForm = ({ equipmentAssignment }) => {
		if (!equipmentAssignment) {
			return;
		}
		const newState = {};
		[
			'equipmentAssignmentId',
			'equipmentId',
			'equipmentId2',
			'equipmentAssignmentTypeId',
			'locationId',
			'shiftSchedules',
		].forEach((key) => {
			if (_.isNil(equipmentAssignment[key])) {
				return;
			}
			newState[key] = equipmentAssignment[key];
		});
		this.setState(newState);
	};

	formatEquipmentByTerminal = ({ equipmentAssignments }) => {
		const { locationMap, equipmentMap, shiftMap } = this.props;
		const byLocationId = {};

		equipmentAssignments.forEach((equipmentAssignment) => {
			const { locationId, equipmentId, shiftSchedules } = equipmentAssignment;

			const location = locationMap[locationId] || { display: 'Missing' };

			if (!byLocationId[locationId]) {
				byLocationId[locationId] = {
					sort: location.display,
					location,
					locationId,
					byShiftId: {},
					count: 0,
				};
			}
			const locRef = byLocationId[locationId];
			locRef.count++;

			shiftSchedules.forEach((shiftSchedule) => {
				const { shiftId, shiftTime } = shiftSchedule;

				if (!locRef.byShiftId[shiftId]) {
					locRef.byShiftId[shiftId] = {
						shiftId,
						shift: shiftMap[shiftId] || { display: 'Missing' },
						shiftAssignments: [],
					};
				}

				locRef.byShiftId[shiftId].shiftAssignments.push({
					shiftTime,
					equipment: equipmentMap[equipmentId] || { display: 'Missing ' },
				});
			});
		});

		_.keys(locationMap).forEach((locationId) => {
			if (byLocationId[locationId]) {
				return;
			}

			const location = locationMap[locationId] || { display: 'Missing' };

			byLocationId[locationId] = {
				sort: location.display,
				location,
				locationId: parseInt(locationId, 10),
				byShiftId: {},
				count: 0,
			};
		});

		const equipmentAssignmentsByLocation = [];
		_.sortBy(_.values(byLocationId), 'sort').forEach((byLocation) => {
			const { byShiftId, count, location, locationId } = byLocation;

			//- Final row to push
			const row = {
				locationId,
				location,
				count,
				assignmentTypes: [],
			};

			const shiftRows = [];
			_.sortBy(_.values(byShiftId), 'shiftId').forEach((shiftValue) => {
				const { shiftId, shift, shiftAssignments } = shiftValue;

				shiftRows.push({
					shiftId,
					shiftDisplay: shift.display,
					shiftAssignments: _.sortBy(shiftAssignments, 'shiftTime'),
				});
			});

			row.shiftRows = shiftRows;
			equipmentAssignmentsByLocation.push(row);
		});

		this.setState({ equipmentAssignmentsByLocation });
	};

	handleSave = () => {
		const { addEquipmentAssignment, updateEquipmentAssignment, showErrors } = this.props;

		const {
			isUpdate,
			isReassign,
			equipmentId,
			equipmentId2,
			equipmentAssignmentTypeId,
			equipmentAssignmentId,
			startDate,
			endDate,
			locationId,
			shiftSchedules,
		} = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		/** @namespace moment.tz **/
		if (!isUpdate) {
			if (moment().tz(calendarConfig.timezone).format('YYYY-MM-DD') > startDate) {
				formFieldError.startDate = `When updating an assignment, startDate cannot be in the past`;
			}
		}

		if (_.isEmpty(shiftSchedules)) {
			formFieldError.shiftSchedules = `At least one schedule is required`;
		}

		const userAssignmentType = getEquipmentAssignmentType({ equipmentAssignmentTypeId });
		if (userAssignmentType.isTypeC && !equipmentId2) {
			formFieldError.equipmentId2 = `Both equipments are required`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			equipmentId,
			equipmentId2,
			equipmentAssignmentTypeId,
			endDate,
			locationId,
			shiftSchedules,
		};

		if (!isUpdate) {
			params.startDate = startDate;
		}

		if (!isUpdate && !isReassign) {
			addEquipmentAssignment({
				params,
			});
		} else {
			if (isUpdate) {
				params.isSimpleUpdate = true;
				delete params.startDate;
			}
			params.equipmentAssignmentId = equipmentAssignmentId;
			updateEquipmentAssignment({
				params,
			});
		}
	};

	/*
onChange = (value, path, error) => {
	const arrayPath = _.toPath(path);
	const basePath = _.head(arrayPath);
	let base = this.state[basePath];
	let newState = {};

	if (_.isArray(base) || _.isObject(base)) {
		if (arrayPath.length > 1) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}
	} else {
		newState[basePath] = value;
	}

	//- Clear any errors on the path
	let formFieldError = Object.assign({}, this.state.formFieldError);

	if (error) {
		formFieldError[path] = error;
	} else {
		delete formFieldError[path];
	}
	newState.formFieldError = formFieldError;
	this.setState(newState);
};

	getInputProps = (path, defaultValue) => {
		return {
			key : path,
			path,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	setForm = (path, label, isRequired, defaultValue) => {
		if (isRequired) {
			this.requiredPathMap[path] = { path, label};
		}
		return {
			key : path,
			path,
			label,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};
 */

	render() {
		const { permissions, classes } = this.props;

		const { isUpdate, isReassign, locationId } = this.state;

		if (!permissions || !_.includes(permissions, 'canUpdateScheduling')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}

		const action = isUpdate
			? 'Update Truck Assignment'
			: isReassign
			? 'Reassign Truck Assignment'
			: 'Create Truck Assignment';
		return (
			<FormContainer headline={`${action}`}>
				<LocationSelect {...this.setForm('locationId', 'Terminal', true)} />

				<Grid item xs={12}>
					<div className={classes.pickToShow}>
						<EquipmentAssignmentTable
							includeEdit={false}
							selectedLocationId={locationId ? parseInt(locationId) : null}
							showPast={false}
						/>
					</div>
				</Grid>

				<Grid item xs={12} sm={6}>
					<Grid container spacing={2}>
						<SectionHeader label={'Schedule Type'} gridProps={{ md: 12 }} />

						<EquipmentScheduleTypeSelect
							{...this.setForm('equipmentAssignmentTypeId', 'Equipment Schedule', true)}
							selectedLocationId={parseInt(locationId, 10)}
						/>

						<SectionHeader label={'Equipment'} gridProps={{ md: 12 }} />
						{this.renderEquipmentSelect()}

						<SectionHeader label={'Shift and Start'} gridProps={{ md: 12 }} />

						<EquipmentAssignmentShiftSchedules {...this.setForm('shiftSchedules')} />

						{!isUpdate && (
							<FormDatePicker
								{...this.setForm('startDate', 'Start date', true)}
								helpText={'When will this truck first be available for new assignment'}
							/>
						)}
					</Grid>
				</Grid>

				<FormSubmitButton onClick={this.handleSave} buttonText={`${action}`} />
			</FormContainer>
		);
	}

	renderEquipmentSelect = () => {
		const { classes } = this.props;
		const { equipmentAssignmentTypeId, locationId, isUpdate, isReassign } = this.state;

		if (!equipmentAssignmentTypeId) {
			return (
				<Grid item xs={12}>
					<div className={classes.globalPleasePick}>Please pick a schedule type</div>
				</Grid>
			);
		}

		const userAssignmentType = getEquipmentAssignmentType({ equipmentAssignmentTypeId });

		if (userAssignmentType.isTypeC) {
			const { equipmentAssignmentId } = this.state;
			return (
				<>
					<SmartEquipmentSelect
						{...this.setForm('equipmentId', 'Share Truck Currently on A Schedule')}
						filterType={'availableForCSchedule'}
						wantTypeA={true}
						selectedLocationId={locationId ? parseInt(locationId) : null}
						equipmentAssignmentId={equipmentAssignmentId}
					/>

					<SmartEquipmentSelect
						{...this.setForm('equipmentId2', 'Shared Truck Currently on B Schedule')}
						filterType={'availableForCSchedule'}
						wantTypeB={true}
						selectedLocationId={locationId ? parseInt(locationId) : null}
						equipmentAssignmentId={equipmentAssignmentId}
					/>
				</>
			);
		} else {
			const includeEquipmentIds = [];
			if (isUpdate || isReassign) {
				includeEquipmentIds.push(this.state.equipmentId);
			}

			let wantTypeA = false;
			let wantTypeB = false;
			const userAssignmentType = getEquipmentAssignmentType({ equipmentAssignmentTypeId });
			if (userAssignmentType.isTypeA) {
				wantTypeA = true;
			} else {
				wantTypeB = true;
			}

			return (
				<SmartEquipmentSelect
					{...this.setForm('equipmentId', 'Truck', true)}
					filterType={'availableTruckNewAOrBSchedule'}
					includeEquipmentIds={includeEquipmentIds}
					wantTypeA={wantTypeA}
					wantTypeB={wantTypeB}
				/>
			);
		}
	};
}

/*

	After you pick the vehicle it pulls information about hta vehicle
 */

SaveEquipmentAssignment.propTypes = {
	getEquipmentAssignment: PropTypes.func.isRequired,
	addEquipmentAssignment: PropTypes.func.isRequired,
	updateEquipmentAssignment: PropTypes.func.isRequired,
	equipmentAssignment: PropTypes.object,

	searchEquipmentAssignmentsByEquipment: PropTypes.func.isRequired,

	searchEquipmentAssignments: PropTypes.func.isRequired,
	equipmentAssignments: PropTypes.array,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, EquipmentAssignmentContainer])(
	SaveEquipmentAssignment
);
